import axios from 'axios'
import settings from '../../settings'

const instance = axios.create({
  baseURL: settings.baseApi
})

instance.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user) {
      config.headers.Authorization = `Bearer ${user.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
